//@flow

import * as React from 'react';
import { Image } from '@locus-taxy/neo-ui';
import { useProvider } from 'common/modules/provider';

const LeftBarIcon = (): React.Node => {
    const { assets } = useProvider();
    return <Image maxHeight="24px" src={assets.smallLogoSrc} />;
};
export default LeftBarIcon;
